


<div class="col-lg-12 ml-3 text-right mb-2 mx-1 ps-4" *ngIf="ContactRelation.Relationtype == 'SupportPlanner'">
  <button class="btn blue-btn btn-sm ms-2" data-bs-toggle="modal" [disabled]="global.viewTabs"
    data-bs-target="#addmodalSupportplanner" 
    >Add SupportPlanner</button> 

     <button class="btn blue-btn btn-sm ms-2" data-bs-toggle="modal" [disabled]="global.viewTabs"
    data-bs-target="#modalRelationSupportplanner"   (click)="clearCli_support()"
    >Assign SupportPlanner</button> 
</div>


<div class="row" *ngIf="ContactRelation.Relationtype == 'SupportPlanner'">
  <div class="col-12">
 <ejs-grid #gridsupportrelation id="gridrelation" [dataSource]='datasupportrealtion |async' [allowResizing]='true' [allowFiltering]='true'
                  [pageSettings]='initialPage' [filterSettings]='filterOptions' [showColumnChooser]='true'
                  [allowSorting]='true' allowPaging='true' (actionBegin)="onActionComplete($event)"
                  (dataStateChange)='dataStateChangenotes($event)'>
                  <e-columns>
                    <e-column minWidth=100 uid="action" headerText="Actions" textAlign="center"
                      [showInColumnChooser]='false'>
                      <ng-template #template let-data>
                        <button class="btn btn-edit-table me-2"  [disabled]="global.viewTabs" data-bs-target="#modalRelationSupportplanner" data-bs-toggle="modal"
                          (click)="editData(data)" ><i class="fa fa-edit"></i></button>

                        <button class="btn btn-delete-table "   [disabled]="global.viewTabs" data-bs-target="#modalSupportrelationdelete"
                          (click)="setDeleteId(data.id)" data-bs-toggle="modal"  ><i class="fa fa-trash"></i></button>
                      </ng-template>

                    </e-column>
                    <e-column minWidth=100 field="activeDate" headerText="ActiveDate" type="date"  [format]="formatOptions">
                      <!-- <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template> -->
                    </e-column>
                     <e-column minWidth=100 field="inActiveDate" headerText="InActiveDate" type="date"  [format]="formatOptions">
                      <!-- <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template> -->
                    </e-column>
                        <e-column minWidth=100 field="supportPlannerName" headerText="Support Planner Name" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                     <e-column minWidth=100 field="statusName" headerText="Status Name" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth=100 field="fax" headerText="Fax" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth=100 field="email" headerText="Email" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                

                    <!--------------------------------table header icon---------------->
                    <e-column width="50" [showInColumnChooser]='false'>
                      <ng-template #headerTemplate let-data>
                        <div>
                          <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                            </i></span>
                        </div>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
  </div>
</div>


<span id="openSupportRelationModal" data-bs-target="#modalRelationSupportplanner" data-bs-toggle="modal"></span>
<div class="modal fade" id="modalRelationSupportplanner" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content"> 
       <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel"><span
            > Assign SupportPlanner
            </span>
         
        </h5>
        <button type="button" class="btn-close"  data-bs-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>    
      <div class="modal-body">
             <div class="row mt-2">
                <div class="col-lg-5">
                  <label>Assign Supportplanner<sup class="super-script">*</sup></label>
                </div>
                <div class="col-lg-7">
                   <select class="form-control" [(ngModel)]="ClientSupportRelationShipBO.supportPlannerId"
                    >
                    <option value=" "></option>
                    <option [value]="ContactType.Key" *ngFor="let ContactType of SupportPlannersList">
                      {{ContactType.Value}}</option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-lg-5">
                  <label>Start Date<sup class="super-script">*</sup></label>
                </div>
                <div class="col-lg-7">
                 <my-date-picker class="w-100" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
              [selDate]="ClientSupportRelationShipBO.activeDate" (inputFieldChanged)="DateFormat($event,'inputchanged','SaveStartDate')"
              (dateChanged)="DateFormat($event,'datechanged','SaveStartDate')">
            </my-date-picker>

                </div>
              </div>
          <div class="row mt-2">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-5">
                  <label>End Date
                  </label>
                </div>
                <div class="col-lg-7">
                  <my-date-picker class="w-100" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
              [selDate]="ClientSupportRelationShipBO.inActiveDate" (inputFieldChanged)="DateFormat($event,'inputchanged','SaveEndDate')"
              (dateChanged)="DateFormat($event,'datechanged','SaveEndDate')">
            </my-date-picker>

                </div>
              </div>
            </div>
           
          </div>

          
      </div> 
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" (click)="SaveOrUpdateRelationInfo();" 
          [disabled]="ClientSupportRelationShipBO.supportPlannerId == null || ClientSupportRelationShipBO.supportPlannerId == '' ||
          ClientSupportRelationShipBO.supportPlannerId == undefined || ClientSupportRelationShipBO.activeDate == null || 
          ClientSupportRelationShipBO.activeDate == '' || 
          ClientSupportRelationShipBO.activeDate == undefined">
          <span *ngIf="ClientSupportRelationShipBO.id=='00000000-0000-0000-0000-000000000000'">
            Save & Close  </span>
           <span *ngIf="ClientSupportRelationShipBO.id!='00000000-0000-0000-0000-000000000000'">
            Update & Close  </span>
        </button>
        
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="clearCli_support()"
          >Close</button>
      </div>     
    </div>
      
  </div>
</div>


<span id="openSupportModal" data-bs-target="#addmodalSupportplanner" data-bs-toggle="modal"></span>
<div class="modal fade" id="addmodalSupportplanner" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content"> 
       <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel"><span
            > SupportPlanner
            </span>
         
        </h5>
        <button type="button" class="btn-close"  data-bs-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>    
      <div class="modal-body">
             <!-- <div class="row mt-2">
                <div class="col-lg-5">
                  <label>Assign Supportplanner<sup class="super-script">*</sup></label>
                </div>
                <div class="col-lg-7">
                   <select class="form-control" [(ngModel)]="ClientSupportRelationShipBO.supportPlannerId"
                    >
                    <option [value]="ContactType.Key" *ngFor="let ContactType of SupportPlannersList">
                      {{ContactType.Value}}</option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-lg-5">
                  <label>Start Date<sup class="super-script">*</sup></label>
                </div>
                <div class="col-lg-7">
                 <my-date-picker class="w-100" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
              [selDate]="ClientSupportRelationShipBO.activeDate" (inputFieldChanged)="DateFormat($event,'inputchanged','SaveStartDate')"
              (dateChanged)="DateFormat($event,'datechanged','SaveStartDate')">
            </my-date-picker>

                </div>
              </div>
          <div class="row mt-2">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-5">
                  <label>End Date
                  </label>
                </div>
                <div class="col-lg-7">
                  <my-date-picker class="w-100" [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
              [selDate]="ClientSupportRelationShipBO.inActiveDate" (inputFieldChanged)="DateFormat($event,'inputchanged','SaveEndDate')"
              (dateChanged)="DateFormat($event,'datechanged','SaveEndDate')">
            </my-date-picker>

                </div>
              </div>
            </div>
           
          </div> -->

          <app-supportplanner></app-supportplanner>
      </div> 
      <div class="modal-footer">
        
        
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="clearCli_support()"
          >Close</button>
      </div>     
    </div>
      
  </div>
</div>







<span id="openSupportdelete" data-bs-toggle="modal" data-bs-target="#modalSupportrelationdelete"></span>
<div class="modal fade" id="modalSupportrelationdelete" data-bs-backdrop="static">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Delete </span>
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to Delete?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="DeleteClientSupport()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>